<template>
    <div v-if="!isDismissed && shouldDisplay"
        class="relative isolate flex items-center gap-x-6 overflow-hidden px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
        <!-- Background gradient left-side -->
        <div class="absolute left-[max(-7rem,calc(50%-52rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
            aria-hidden="true">
            <div class="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[var(--secondary-blue)] to-[var(--primary-blue)] opacity-30"
                style="
                    clip-path: polygon(
                        74.8% 41.9%,
                        97.2% 73.2%,
                        100% 34.9%,
                        92.5% 0.4%,
                        87.5% 0%,
                        75% 28.6%,
                        58.5% 54.6%,
                        50.1% 56.8%,
                        46.9% 44%,
                        48.3% 17.4%,
                        24.7% 53.9%,
                        0% 27.9%,
                        11.9% 74.2%,
                        24.9% 54.1%,
                        68.6% 100%,
                        74.8% 41.9%
                    );
                "></div>
        </div>
        <!-- Background gradient right-side -->
        <div class="absolute left-[max(45rem,calc(50%+8rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
            aria-hidden="true">
            <div class="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[var(--secondary-blue)] to-[var(--primary-blue)] opacity-30"
                style="
                    clip-path: polygon(
                        74.8% 41.9%,
                        97.2% 73.2%,
                        100% 34.9%,
                        92.5% 0.4%,
                        87.5% 0%,
                        75% 28.6%,
                        58.5% 54.6%,
                        50.1% 56.8%,
                        46.9% 44%,
                        48.3% 17.4%,
                        24.7% 53.9%,
                        0% 27.9%,
                        11.9% 74.2%,
                        24.9% 54.1%,
                        68.6% 100%,
                        74.8% 41.9%
                    );
                "></div>
        </div>
        <div class="flex flex-wrap items-center gap-x-2 gap-y-2">
            <a class="text-base text-white leading-6" :href="ctaUrl">
                <strong class="font-semibold">{{ title }}</strong>
                <span v-if="message">
                    <svg viewBox="0 0 2 2" class="mx-2 inline h-0.5 w-0.5 fill-current" aria-hidden="true">
                        <circle cx="1" cy="1" r="1" />
                    </svg>
                    {{ message }}
                    <Icon v-if="!ctaText" name="material-symbols:arrow-forward" />
                </span>
            </a>
            <a v-if="ctaUrl && ctaText" :href="ctaUrl">
                <button class="flex-none px-3.5 py-1 btn btn-secondary">
                    {{ ctaText }}
                    <span aria-hidden="true">&rarr;</span>
                </button>
            </a>
            <a v-if="termsUrl" class="text-xs underline cursor-pointer" :href="termsUrl">
                {{ termsText }}
            </a>
        </div>
        <div class="flex flex-1 justify-end text-white">
            <button type="button" @click="dismissBanner">
                <span class="sr-only">Dismiss</span>
                <Icon name="material-symbols:close" class="text-xl" />
            </button>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    name: 'AppBanner',
    props: {
        title: {
            type: String,
            default: 'Disclaimer',
        },
        message: {
            type: String,
            default: 'Message to all users.',
        },
        ctaUrl: {
            type: String,
            default: null,
        },
        ctaText: {
            type: String,
            default: null,
        },
        termsUrl: {
            type: String,
            default: null,
        },
        termsText: {
            type: String,
            default: 'Terms and Conditions',
        },
        expirationDate: {
            type: Date,
            default: null,
        },
    },
    data() {
        return {
            isDismissed: false,
        };
    },
    computed: {
        shouldDisplay() {
            if (this.isExpired) return false;
            return true
        },
        isExpired() {
            if (!this.expirationDate) return false;
            return new Date() > this.expirationDate;
        },
    },
    methods: {
        dismissBanner() {
            this.isDismissed = true;
        },
    },
};
</script>
